<template>
  <div class="module_page cal_events" aria-label="Calendar List Page">
    <div class="row page_content">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">

        <div class="page-heading">
          <div class="row">
            <div class="col-xl-7 col-lg-7 col-md-12 col-sm-12 input module_heading" role="heading" aria-level="1">
              <div class="module_icon ic22-dateRange"></div>
              <label class="head_txt module_type_name ace_sec_hd" role="heading" aria-label="Calendar">Calendar <template v-if="advisee.userName">({{advisee.userName}})</template></label>
            </div>
            <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 search_field pl-5" v-if="!isStudentLogin">
              <b-button @click="showAddCalendarEventModal">Add</b-button>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 search_field">
              <input placeholder="search by calendar event title" aria-label="search by calendar event name" v-model="searchTerm">
              <b-btn class="btn btn_clear btn-secondary" @click="searchTerm = ''" v-if="searchTerm.length > 0">
                <span class="ic-close"></span>
              </b-btn>
            </div>
          </div>
        </div>

        <template v-if="isCalendarEventsLoaded">
          <template v-if="calendarEvents.length > 0">
            <template v-if="filteredCalendarEvents.length > 0">
              <div class="row lst_pg__row" v-for="calEvent in filteredCalendarEvents"  @mouseover="mouseOver(calEvent)" @mouseleave="mouseLeave(calEvent)">
                <div class="col-12">
                  <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col_date">
                      <div>{{calEvent.formattedStartDateTime}}</div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col_title">
                      <div>{{calEvent.title}}</div>
                      <div class="members"><small>{{calEvent.who}}</small></div>
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col_location">
                      <div class="row">
                        <div class="col-1 ic ic9-location2"></div>
                        <div class="col-11 location_txt">{{calEvent.location}}</div>
                      </div>
                    </div>
                    <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 action" v-if="(userId === calEvent.creatorId)">
                      <template v-if="calEvent.active">
                        <div class="menu">
                          <span class="ic_btn icon-bin" @click="showDeleteCalendarEventModal(calEvent)"></span>
                          <span class="ic_btn ic2_pencil" @click="showEditCalendarEventModal(calEvent)"></span>
                        </div>
                      </template>
                      <template v-else>
                        <span class="ic9-iconMore-0005 cal-event-list-dotted-menu ic_more"></span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mt-5 text-center">
                <h4>No results found!</h4>
              </div>
            </template>
          </template>
          <template v-else>
            <div class="mt-5 text-center">
              <h4>You don't have any calendar event.</h4>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div>
      <b-modal class="h-100 d-inline-block" id="add-calendar-event-popup" ref="addCalendarEventModal" :header-bg-variant="'calendar-event-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="edit-cal-event-popup-head-txt">
            <span>Setting Calendar Event</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="cancelAddCalendarEvent">
              <span class="ic-close"></span>
            </button>
          </div>
          <div class="float-right mr-4">
            <b-button @click="saveCalendarEvent" :disabled="($v.$invalid || (selectedAdvisees.length === 0))">Save</b-button>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">What <sup>*</sup></div>
              <div class="col-10 fld_input">
                <b-form-input v-model.trim="eventSummary" style="height: 25px !important; width: 95%" @blur="$v.eventSummary.$touch()"></b-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">When <sup>*</sup></div>
              <div class="col-4 fld_input">
                <datetime
                  type="datetime" v-model="eventDateTime"
                  :format="{year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit'}"
                  value-zone="America/New_York"
                  zone="America/New_York"
                  :hour-step="1"
                  :minute-step="5"
                  :min-datetime="minDatetime"
                  :week-start="7"
                  use12-hour
                  auto
                  input-style="width: 100%; height: 34px;" @blur="$v.eventDateTime.$touch()">
                </datetime>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">Where <sup>*</sup></div>
              <div class="col-8 fld_input">
                <b-form-input v-model.trim="eventLocation" style="height: 25px !important; width: 95%" @blur="$v.eventLocation.$touch()"></b-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">Who <sup>*</sup></div>
              <div class="col-10 fld_input select_bx">
                <v-select v-model="selectedAdvisees" :options="advisees" label="displayName"
                  multiple @blur="$v.eventDateTime.$touch()" style="height: 25px !important; width: 95%">
                </v-select>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

    <div>
      <b-modal id="edit-calendar-event-popup" ref="editCalendarEventModal" :header-bg-variant="'calendar-event-popup-header'" size="xl" hide-footer no-close-on-backdrop no-close-on-esc>
        <div slot="modal-header" class="header-section w-100">
          <div class="edit-cal-event-popup-head-txt">
            <span>{{calendarEventHeaderText}}</span>
          </div>
          <div class="float-right">
            <button class="btn_close" aria-label="close" @click="cancelEditCalendarEvent">
              <span class="ic-close"></span>
            </button>
          </div>
          <div class="float-right mr-5">
            <b-button @click="updateCalendarEvent" :disabled="$v.$invalid || !dirty">Update Calendar Event</b-button>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">What <sup>*</sup></div>
              <div class="col-10 fld_input">
                <b-form-input v-model.trim="eventSummary" style="height: 25px !important; width: 95%" @blur="$v.eventSummary.$touch()"></b-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">When <sup>*</sup></div>
              <div class="col-4 fld_input">
                <datetime
                  type="datetime" v-model="eventDateTime"
                  :format="{year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit'}"
                  value-zone="America/New_York"
                  zone="America/New_York"
                  :hour-step="1"
                  :minute-step="5"
                  :min-datetime="minDatetime"
                  :week-start="7"
                  use12-hour
                  auto
                  input-style="width: 100%; height: 34px;" @blur="$v.eventDateTime.$touch()">
                </datetime>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">Where <sup>*</sup></div>
              <div class="col-8 fld_input">
                <b-form-input v-model.trim="eventLocation" style="height: 25px !important; width: 95%" @blur="$v.eventLocation.$touch()"></b-form-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row fld_row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 fld_label">Who</div>
              <div class="col-10 fld_input">
                <b-form-input :value="selectedCalendarEvent.who" readonly style="height: 25px !important; width: 95%"></b-form-input>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal id="delete-calendar-event-popup" ref="deleteCalendarEventModal" :header-bg-variant="'calendar-event-popup-header'" title="Deleting Calendar Event" hide-header-close no-close-on-backdrop no-close-on-esc centered>
        <div class="text-center">
          <h6>Are you sure you want to delete this calendar event? This cannot be undone.</h6>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteCalendarEvent" class="btn button-primary float-right mr-2">Delete Calendar Event</b-button>
          <b-link class="float-right mr-4 mt-1" @click="cancelDeleteCalendarEvent">No, Do not delete</b-link>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {  mapActions } from 'vuex'
  import { DateTime } from 'luxon'
  import { Datetime } from 'vue-datetime'
  import 'vue-datetime/dist/vue-datetime.css'
  import { required } from 'vuelidate/lib/validators'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'calendar-event-list',
    props: ['userUuid'],
    components: {
      Datetime
    },
    data: () => {
      return {
        uuid: '',
        advisee: {},
        dirty: false,
        advisees: [],
        userUuids: [],
        searchTerm: '',
        eventSummary: '',
        eventLocation: '',
        eventDateTime: '',
        calendarEvents: [],
        selectedAdvisees: [],
        selectedCalendarEvent: '',
        calendarEventHeaderText: '',
        isCalendarEventsLoaded: false,
        minDatetime: DateTime.utc().toISO(),
        userId: localStore.getItem('userid'),
        userrole: localStore.getItem('userrole')
      }
    },
    validations () {
      return {
        eventSummary: {
          required
        },
        eventLocation: {
          required
        },
        eventDateTime: {
          required
        }
      }
    },
    watch: {
      eventSummary (newVal, oldValue) {
        let isEmpty = _.isEmpty(newVal) || _.isEmpty(oldValue)
        this.dirty = !isEmpty && (newVal !== oldValue)
      },
      eventLocation (newVal, oldValue) {
        let isEmpty = _.isEmpty(newVal) || _.isEmpty(oldValue)
        this.dirty = !isEmpty && (newVal !== oldValue)
      },
      eventDateTime (newVal, oldValue) {
        let isEmpty = _.isEmpty(newVal) || _.isEmpty(oldValue)
        this.dirty = !isEmpty && (newVal !== oldValue)
      }
    },
    computed: {
      isStudentLogin () {
        return (this.userrole === 'Student')
      },
      filteredCalendarEvents () {
        return this.calendarEvents.filter(item => {
          return item.title.toLowerCase().includes(this.searchTerm.toLowerCase())
        })
      }
    },
    async mounted () {
      if (this.userUuid) {
        this.advisee = await this.loadAdviseeDetail(this.userUuid)
      }
      await this.loadCalendarEevents()
      this.advisees = await this.loadDirectChannelUsers()
    },
    methods: {
      ...mapActions([
        'loadAdviseeDetail',
        'loadAllCalendarEvents',
        'loadSaveCalendarEvent',
        'loadDirectChannelUsers',
        'loadDeleteCalendarEvent',
        'loadCalendarEventsForParticipants'
      ]),
      showLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$root.$refs.loadingModal) {
          this.$root.$refs.loadingModal.hide()
        }
      },
      async loadCalendarEevents () {
        this.calendarEvents = []
        let calEvents = this.userUuid ? await this.loadCalendarEventsForParticipants([this.userUuid]) : await this.loadAllCalendarEvents()
        this.populateCalendarEvents(calEvents)
      },
      populateCalendarEvents (calEvents) {
        calEvents.forEach(calEvent => {
          let users = []
          _.forEach(calEvent.participantDetails, (p) => {
            users.push(p.firstName + ' ' + p.lastName)
          })
          let who = users.join(', ').replace(/,(?=[^,]*$)/, ' and')
          calEvent.who = who
          calEvent.active = false
          this.calendarEvents.push(calEvent)
        })
        this.isCalendarEventsLoaded = true
      },
      mouseOver(calEvent) {
        calEvent.active = true
      },
      mouseLeave(calEvent) {
        calEvent.active = false
      },
      showAddCalendarEventModal () {
        this.$refs.addCalendarEventModal.show()
      },
      async saveCalendarEvent () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          let text = '<b><sup>*</sup></b> fields are required'
          this.showNotification(text, 'error')
          return
        }
        this.showLoader()
        this.selectedAdvisees.forEach(advisee => {
          this.userUuids.push(advisee.userUuid)
        })
        let data = {
          title: this.eventSummary,
          location: this.eventLocation,
          participants: this.userUuids,
          description: this.eventSummary,
          startDateTime: this.eventDateTime,
          formattedStartDateTime: this.formatDate(this.eventDateTime)
        }
        let text = 'Calendar Event Created Sccessfully'
        let resp = await this.loadSaveCalendarEvent(data)
        if (resp) {
          this.hideLoader()
          this.loadCalendarEevents()
          this.cancelAddCalendarEvent()
          this.showNotification(text, 'success')
        } else {
          this.showNotification('Something went wrong.', 'error')
        }
      },
      cancelAddCalendarEvent () {
        this.userUuids = []
        this.eventSummary = ''
        this.eventLocation = ''
        this.eventDateTime = ''
        this.selectedAdvisees = []
        this.$refs.addCalendarEventModal.hide()
      },
      showDeleteCalendarEventModal (event) {
        this.selectedCalendarEvent = event
        this.$refs.deleteCalendarEventModal.show()
      },
      deleteCalendarEvent () {
        let uuid = this.selectedCalendarEvent.uuid
        let text = '<strong>' + this.selectedCalendarEvent.title + '</strong> deleted successfully.'
        this.loadDeleteCalendarEvent(uuid).then(resp => {
          this.loadCalendarEevents()
          this.cancelDeleteCalendarEvent()
          this.showNotification(text, 'success')
        })
      },
      cancelDeleteCalendarEvent () {
        this.selectedCalendarEvent = ''
        this.$refs.deleteCalendarEventModal.hide()
      },
      showEditCalendarEventModal (event) {
        this.uuid = event.uuid
        this.eventSummary = event.title
        this.eventLocation = event.location
        this.eventDateTime = event.startDateTime
        this.userUuids = event.participants
        this.selectedCalendarEvent = event
        let who = event.who
        this.calendarEventHeaderText = 'Updating Calendar Event For '
        let count = (this.userUuids.length - 1)
        if (count > 1) {
          this.calendarEventHeaderText += count + ' People'
        } else {
          this.calendarEventHeaderText += who
        }
        this.$refs.editCalendarEventModal.show()
      },
      cancelEditCalendarEvent () {
        this.uuid = ''
        this.userUuids = []
        this.eventSummary = ''
        this.eventLocation = ''
        this.eventDateTime = ''
        this.calendarEventHeaderText = ''
        this.$refs.editCalendarEventModal.hide()
        this.selectedCalendarEvent = ''
      },
      async updateCalendarEvent () {
        this.$v.$touch()
        if (this.$v.$invalid) {
          let text = '<b><sup>*</sup></b> fields are required'
          this.showNotification(text, 'error')
          return
        }
        this.showLoader()
        let data = {
          uuid: this.uuid,
          title: this.eventSummary,
          location: this.eventLocation,
          description: this.eventSummary,
          participants: this.userUuids,
          startDateTime: this.eventDateTime,
          formattedStartDateTime: this.formatDate(this.eventDateTime)
        }
        let text = 'Calendar Event Updated Sccessfully For <strong>' + this.selectedCalendarEvent.who + '</strong>'
        let resp = await this.loadSaveCalendarEvent(data)
        if (resp) {
          this.hideLoader()
          this.loadCalendarEevents()
          this.cancelEditCalendarEvent()
          this.showNotification(text, 'success')
        } else {
          this.showNotification('Something went wrong.', 'error')
        }
      },
      showNotification (text, type) {
        this.$notify({
          group: 'notify',
          type: type,
          title: '',
          text: text
        })
      },
      formatDate (selected) {
        return DateTime.fromISO(selected, {zone: 'America/New_York'}).toFormat('ccc LLL dd, yyyy h:mm a (ZZZZ)')
      }
    }
  }
</script>

<style>
  .cal_events .page-heading .search_field {
    position: relative;
    margin-top: 21px;
  }

  .cal_events .page-heading .search_field input {
    width: calc(100% - 18px);
    padding: 2px 10px 7px 8px;
    border-radius: 2px;
  }

  .cal_events .page-heading .search_field .btn_clear {
    position: absolute;
    right: 18px;
    top: -3px;
    outline: none;
  }

  .edit-cal-event-popup-head-txt {
    float: left;
    color: #323232;
    font-weight: 800;
    font-size: 1.4rem;
    width: 75%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bg-calendar-event-popup-header {
    background: #eaf8ff !important;
  }

  sup {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/CalendarEventList.vue